import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=c018f1d4&"
import script from "./PageFooter.vue?vue&type=script&setup=true&lang=js&"
export * from "./PageFooter.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports